import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { useIsLoadingBarNextRoute } from 'integration/hooks/useIsLoadingNextRoute';

const BarContainer = styled(Box)({
	position: 'sticky',
	top: 0,
	left: 0,
	width: '100%',
	zIndex: 9002,
	pointerEvents: 'none',
});

export function LoadingBar({
	height = 3,
	startDelayMs = 50,
	finishHoldMs = 500,
}: {
	height?: number;
	startDelayMs?: number;
	finishHoldMs?: number;
}) {
	const { visible, progress } = useIsLoadingBarNextRoute({
		startDelayMs,
		finishHoldMs,
	});

	if (!visible) {
		return null;
	}

	return (
		<BarContainer sx={{ height }}>
			<LinearProgress
				variant="determinate"
				value={progress}
				sx={{
					height,
					backgroundColor: 'rgba(0, 0, 0, 0.1)',
					'& .MuiLinearProgress-bar': {
						backgroundColor: (theme) => theme.palette.primary.main,
						transition: 'transform 0.2s ease-in-out',
					},
				}}
			/>
		</BarContainer>
	);
}
